import React from "react";

const Button = ({title}) => {
  return (
    <button className=" bg-[#262626] py-4 px-24 text-white font-dm font-bold text-sm">{title}</button>
  );
};

export default Button;
